<template>
  <div class="linked-accounts-section">
    <div class="linked-accounts-title">Linked Accounts</div>
    <div v-if="Object.keys(socialMediaLinks).length > 0" class="social-media-badges">
      <a
        v-for="(link, platform) in socialMediaLinks"
        :key="platform"
        :href="link.url"
        target="_blank"
        rel="noopener noreferrer"
        class="social-badge"
        :title="`${link.name} Profile`"
      >
        <img :src="link.logo" :alt="link.name" class="social-logo" />
      </a>
    </div>
    <div v-else class="no-accounts-message">
      No linked accounts
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMediaLinks",
  props: {
    socialMedia: {
      type: Object,
      default: () => ({}),
    },
    stripeId: {
      type: String,
      default: null,
    },
  },
  computed: {
    socialMediaLinks() {
      const links = {};
      const platforms = {
        strava: {
          name: "Strava",
          baseUrl: "https://www.strava.com/athletes/",
          logo: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjk0IDEyLjg2N0w5LjAwMyAxNi43MjJIMTEuMDQ5TDEyLjk4NiAxMi44NjdMMTYuNzM5IDQuNzU2SDE0LjY5M0wxMC45NCAxMi44NjdaTTEyLjk4NiAxMi44NjdMMTQuOTI0IDE2LjcyMkgxNi45NjlMMTUuMDMxIDEyLjg2N0wxOC43ODUgNC43NTZIMTYuNzM5TDEyLjk4NiAxMi44NjdaIiBmaWxsPSIjRkM0QzAyIi8+Cjwvc3ZnPgo=",
        },
        instagram: {
          name: "Instagram",
          baseUrl: "https://www.instagram.com/",
          logo: "data:image/svg+xml;base64,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",
        },
        facebook: {
          name: "Facebook",
          baseUrl: "https://www.facebook.com/",
          logo: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDEyQzI0IDUuMzczIDE4LjYyNyAwIDEyIDBTMCA1LjM3MyAwIDEyQzAgMTcuOTkgNC4zODggMjIuOTU0IDEwLjEyNSAyMy44NTRWMTUuNDY5SDcuMDc4VjEySDEwLjEyNVY5LjM1NkMxMC4xMjUgNi4zNDkgMTEuOTE3IDQuNjg4IDE0LjY1OCA0LjY4OEMxNS45NyA0LjY4OCAxNy4zNDQgNC45MjIgMTcuMzQ0IDQuOTIyVjcuODc1SDE1LjgzQzE0LjMzIDcuODc1IDEzLjg3NSA4Ljc5MiAxMy44NzUgOS43MzVWMTJIMTcuMjAzTDE2LjY3MSAxNS40NjlIMTMuODc1VjIzLjg1NEMxOS42MTIgMjIuOTU0IDI0IDE3Ljk5IDI0IDEyWiIgZmlsbD0iIzE4NzdGMiIvPgo8L3N2Zz4K",
        },
        stripe: {
          name: "Stripe",
          baseUrl: "https://dashboard.stripe.com/customers/",
          logo: "data:image/svg+xml;base64,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",
        },
      };

      // Add social media platforms
      for (const [platform, id] of Object.entries(this.socialMedia || {})) {
        if (id && platforms[platform]) {
          links[platform] = {
            name: platforms[platform].name,
            url: platforms[platform].baseUrl + id,
            logo: platforms[platform].logo,
          };
        }
      }

      // Add Stripe if available
      if (this.stripeId) {
        links.stripe = {
          name: platforms.stripe.name,
          url: platforms.stripe.baseUrl + this.stripeId,
          logo: platforms.stripe.logo,
        };
      }

      return links;
    },
  },
};
</script>

<style scoped>
.linked-accounts-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.linked-accounts-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 2px;
}

.social-media-badges {
  display: flex;
  gap: 4px;
  align-items: center;
}

.no-accounts-message {
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

.social-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  transition: all 0.2s ease;
  text-decoration: none;
}

.social-badge:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.social-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
}
</style>